export default __webpack_public_path__ + "static/86-96f1ec5be477cf0573b983f7fd160cb5.png";